// extracted by mini-css-extract-plugin
module.exports = {"alignLeft":"PanelContentHeader_alignLeft__ujGaq","alignCenter":"PanelContentHeader_alignCenter__r02XM","tableCell":"PanelContentHeader_tableCell__oC39Z"};